import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  card: {
    borderRadius: '12px',
    padding: '20px 40px 40px 40px',
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    position: 'relative',
    overflow: 'visible',
    backgroundColor: 'var(--grey-100)'
  } satisfies SxProps<Theme>,
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1em'
  } satisfies SxProps<Theme>,
  header: {
    display: 'flex',
    justifyContent: 'space-between'
  } satisfies SxProps<Theme>,
  surveyContainer: {
    display: 'flex',
    padding: '24px 40px 40px 40px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '28px',
    alignSelf: 'stretch',
    borderRadius: '8px',
    border: '1px solid var(--Theme-primitive-primary-300, #5499C3)',
    background: 'var(--Base-Tones-primitive-surface-100, #FFF)',
    boxShadow: '0 1px 0px 0 rgba(37, 36, 38, 0.08), 0 2px 3px -1px rgba(37, 36, 38, 0.08)'
  } satisfies SxProps<Theme>,
  title: {
    marginLeft: '40px',
    marginTop: '16px',
    marginBottom: '16px'
  } satisfies SxProps<Theme>,
  navButtons: {
    display: 'flex',
    gap: '2em',
    marginTop: '3em',
    justifyContent: 'flex-end',
    width: '100%'
  } satisfies SxProps<Theme>
}
